var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ResponsiveTable',{attrs:{"headers":_vm.headers,"data":_vm.items,"pagination":_vm.pagination,"disabled":_vm.status === 'pending',"status":_vm.status},on:{"changePage":_vm.handlePaginate}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }